export default {
  name: "OneOnOneDashboardBase",
  data() {
    return {
      oneOnOneHeaders: [
        {
          text: "",
          value: "controls",
          sortable: false,
          groupable: false,
          width: 120,
        },
        { text: "Blocks", value: "activeWorkoutBlocks", groupable: false, help: "Current workout blocks" },
        { text: "Nutrition", value: "nutritionPlan", groupable: false },
        { text: "7 day engagement", value: "engagementScore", groupable: false },
        { text: "Last Message", value: "lastMessage", groupable: false },
        { text: "", value: "resolved", groupable: false, help: "Resolve any outstanding messages from this client"},
        {
          text: "Last Coach Checkin",
          value: "lastCoachingAssessmentDate",
          groupable: false,
          help: "Last Coaching Checkin",
        },
        {
          text: "Last User Checkin",
          value: "lastUserAssessmentDate",
          groupable: false,
          help: "Last User Checkin",
        },
      ],
    };
  },
  created() {
    this.table.headers.push(...this.oneOnOneHeaders);
  },
  methods: {
    getAssessmentClass(date) {
      if (!date) {
        return "";
      }
      const weeks = this.$moment().diff(date, "weeks");
      if (weeks < 5) {
        return "green--text";
      }
      if (weeks < 9) {
        return "orange--text";
      }
      return "red--text";
    },
    formatAssessmentDate(date) {
      if (!date) {
        return "";
      }
      return this.$moment(date).fromNow();
    },
  },
};
